module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-M06-clean-ffa0ef732a18eac40ee0b825ff500a26.png";